"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { HeartHandshake, UserCheck, ShieldCheck } from "lucide-react";
export default function ZorgMetAandachtEnContinuiteit() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const features = [{
    icon: <UserCheck className="w-5 h-5 text-primary" />,
    title: "Vaste zorgverleners",
    description: "Zoveel mogelijk vertrouwde gezichten voor rust en herkenbaarheid."
  }, {
    icon: <HeartHandshake className="w-5 h-5 text-primary" />,
    title: "Persoonlijke band",
    description: "Zorg afgestemd op uw wensen, gewoonten en culturele achtergrond."
  }, {
    icon: <ShieldCheck className="w-5 h-5 text-primary" />,
    title: "Vertrouwen & Veiligheid",
    description: "Gediplomeerde professionals die de tijd voor u nemen."
  }];
  return <section id="zorg-met-aandacht-en-continuïteit" className="relative py-20 lg:py-32 bg-accent/30 overflow-hidden" ref={sectionRef}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-accent/50 blur-3xl opacity-60" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-primary/5 blur-3xl opacity-60" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-8 lg:gap-0">
          
          {}
          <div className={`lg:col-start-1 lg:col-end-9 relative transition-all duration-1000 ease-out ${sectionVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-[16/10]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/caregiver_client_laughing_bond.png" alt="Zorgverlener en cliënt lachen samen en hebben een goede band" className="w-full h-full object-cover" />
              {}
              <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent pointer-events-none" />
            </div>
          </div>

          {}
          <div ref={cardRef} className={`lg:col-start-7 lg:col-end-13 z-20 mt-8 lg:-mt-12 transition-all duration-1000 delay-300 ease-out ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <Card className="p-8 sm:p-10 lg:p-12 border-0 shadow-xl bg-background/95 backdrop-blur-md rounded-3xl">
              <div className="space-y-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-accent-foreground text-sm font-medium mb-2">
                  <HeartHandshake className="w-4 h-4" />
                  <span>Continuïteit in zorg</span>
                </div>
                
                <h2 className="text-3xl sm:text-4xl font-serif font-bold text-foreground leading-tight">
                  Zorg met aandacht en continuïteit
                </h2>
                
                <p className="text-muted-foreground text-lg leading-relaxed">
                  Bij CuraNova Zorg geloven we dat goede zorg begint met een vertrouwensband. Daarom streven we ernaar om u zoveel mogelijk te ondersteunen met vaste zorgverleners. Een vertrouwd gezicht over de vloer biedt niet alleen rust, maar zorgt er ook voor dat we uw persoonlijke situatie en behoeften door en door kennen.
                </p>

                <div className="space-y-5 pt-4">
                  {features.map((feature, i) => <div key={i} data-index={i} className="flex items-start gap-4">
                      <div className="mt-1 bg-accent/50 p-2 rounded-lg shrink-0">
                        {feature.icon}
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground">{feature.title}</h3>
                        <p className="text-muted-foreground text-sm mt-1">{feature.description}</p>
                      </div>
                    </div>)}
                </div>

                <div className="pt-6">
                  <Button asChild size="lg" className="w-full sm:w-auto rounded-full">
                    <Link to="/HowWeWorkPage">
                      Lees meer over onze werkwijze
                    </Link>
                  </Button>
                </div>
              </div>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}